import { BaseTabelaPDF, helperPDF, } from '@monorepo-web/pdf-generator';
import { getLayouts } from './layouts';
export default function TabelaPosicaoRendimentoPDF(props) {
    const { rows, theme, titulo = 'Posição e Rendimento por Classe', layout = 'default', moneyPrefix } = props;
    let columns = getLayouts(moneyPrefix)[layout];
    const body = helperPDF.gerarBodyComCor(rows, columns, theme, 3);
    columns = ['', ...columns];
    return BaseTabelaPDF(Object.assign(Object.assign({}, props), { titulo,
        columns, tableConfig: {
            body,
            columnStyleIndex: 1,
        } }));
}
